/**
 * Two types of product a retailer can sell
 * "EXTERNAL_PRODUCT_TYPE" when the product is stored in 3rd party, like amazon and ebay
 * "SQUAREUP_PRODUCT_TYPE" when the product is in square up, we will handle payment and track order
 */
export enum ProductTypeEnum {
  EXTERNAL_PRODUCT_TYPE = 'EXTERNAL_PRODUCT_TYPE',
  SQUAREUP_PRODUCT_TYPE = 'SQUAREUP_PRODUCT_TYPE',
}
